// extracted by mini-css-extract-plugin
export default {"container":"SponsorArea_container__tjUqa","sponsor":"SponsorArea_sponsor__Ei6lz","sponsor-swiper":"SponsorArea_sponsor-swiper__-tYhL"};